import { useState } from 'react'
import ScreenshotViewer from './ScreenshotViewer'
import type { SiteMapScreenshot } from '../schemas/siteMapScreenshot'

export function SiteMapScreenshotPreview({ screenshot, name, highlight = true }: {
  screenshot?: SiteMapScreenshot; name: string; highlight?: boolean
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null)
  if (!screenshot || failedUrl === screenshot.imageUrl) return <span className="site-map__muted">{screenshot ? 'Capture unavailable' : 'Not captured yet'}</span>
  const { bounds, width, height, imageUrl } = screenshot
  // Allow one pixel of rounding at each edge of a full-viewport capture.
  const fillsScreen = bounds.x <= 1 && bounds.y <= 1
    && bounds.x + bounds.width >= width - 1 && bounds.y + bounds.height >= height - 1
  const boxStyle = highlight && !fillsScreen ? {
    left: `${bounds.x / width * 100}%`, top: `${bounds.y / height * 100}%`,
    width: `${bounds.width / width * 100}%`, height: `${bounds.height / height * 100}%`,
  } : undefined
  return <span className="site-map__preview">
    <ScreenshotViewer frame={imageUrl} alt={name} boxStyle={boxStyle}
      onError={() => setFailedUrl(imageUrl)} />
    <a className="site-map__muted" href={`/tasks/${encodeURIComponent(screenshot.taskId)}`}>Source task</a>
  </span>
}
